/**
 * The Architecture page as the URL holds it: which of its three views is
 * shown. The canvas is the one the bare address shows, so it is never written.
 */
export const ARCHITECTURE_VIEWS = ["canvas", "list", "reference"] as const

export type ArchitectureView = (typeof ARCHITECTURE_VIEWS)[number]
export type ArchitectureSearch = { view?: Exclude<ArchitectureView, "canvas"> }

/** Whatever the URL says, a page that can be drawn: it never throws. */
export function parseArchitectureSearch(search: Record<string, unknown>): ArchitectureSearch {
  return search.view === "list" || search.view === "reference" ? { view: search.view } : {}
}
